import SearchBar from "../../components/user/SearchBar"
export default function UserManager () {
    return <SearchBar/>
}
